"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import * as React from "react";
import { cn } from "@/lib/utils";
function ScrollArea({
  className,
  children,
  shadowColor = "black",
  shadowIntensity = 0.05,
  onViewportReady,
  viewportRef: viewportRefProp,
  ...props
}: React.ComponentProps<typeof ScrollAreaPrimitive.Root> & {
  shadowColor?: string;
  shadowIntensity?: number;
  onViewportReady?: () => void;
  viewportRef?: React.RefObject<HTMLDivElement | null>;
}) {
  const [showTopShadow, setShowTopShadow] = React.useState(false);
  const [showBottomShadow, setShowBottomShadow] = React.useState(false);
  const [showLeftShadow, setShowLeftShadow] = React.useState(false);
  const [showRightShadow, setShowRightShadow] = React.useState(false);
  const viewportRef = React.useRef<HTMLDivElement>(null);
  const setViewportRef = React.useCallback((el: HTMLDivElement | null) => {
    (viewportRef as React.MutableRefObject<HTMLDivElement | null>).current = el;
    if (viewportRefProp) {
      (viewportRefProp as React.MutableRefObject<HTMLDivElement | null>).current = el;
    }
    if (el && onViewportReady) {
      onViewportReady();
    }
  }, [onViewportReady, viewportRefProp]);
  const handleScroll = React.useCallback(() => {
    const viewport = viewportRef.current;
    if (!viewport) return;
    const {
      scrollTop,
      scrollLeft,
      scrollHeight,
      scrollWidth,
      clientHeight,
      clientWidth
    } = viewport;

    // Vertical shadows
    setShowTopShadow(scrollTop > 0);
    setShowBottomShadow(scrollTop < scrollHeight - clientHeight);

    // Horizontal shadows
    setShowLeftShadow(scrollLeft > 0);
    setShowRightShadow(scrollLeft < scrollWidth - clientWidth);
  }, []);
  React.useEffect(() => {
    const viewport_0 = viewportRef.current;
    if (!viewport_0) return;

    // Initial check
    handleScroll();

    // Set up ResizeObserver to detect content changes
    const resizeObserver = new ResizeObserver(handleScroll);
    resizeObserver.observe(viewport_0);
    return () => {
      resizeObserver.disconnect();
    };
  }, [handleScroll]);
  return <ScrollAreaPrimitive.Root className={cn("relative", className)} data-slot="scroll-area" {...props}>
			<ScrollAreaPrimitive.Viewport className="focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:outline-1" data-slot="scroll-area-viewport" onScroll={handleScroll} ref={setViewportRef}>
				{children}
			</ScrollAreaPrimitive.Viewport>
			{/* Top shadow */}
			<div className={cn("pointer-events-none absolute top-0 left-0 right-0 h-4 transition-opacity duration-200 z-10", showTopShadow ? "opacity-100" : "opacity-0")} style={{
      background: `linear-gradient(to bottom, rgba(${shadowColor === "black" ? "0,0,0" : "255,255,255"}, ${shadowIntensity}), transparent)`
    }} />

			{/* Bottom shadow */}
			<div className={cn("pointer-events-none absolute bottom-0 left-0 right-0 h-4 transition-opacity duration-200 z-10", showBottomShadow ? "opacity-100" : "opacity-0")} style={{
      background: `linear-gradient(to top, rgba(${shadowColor === "black" ? "0,0,0" : "255,255,255"}, ${shadowIntensity}), transparent)`
    }} />

			{/* Left shadow */}
			<div className={cn("pointer-events-none absolute top-0 bottom-0 left-0 w-4 transition-opacity duration-200 z-10", showLeftShadow ? "opacity-100" : "opacity-0")} style={{
      background: `linear-gradient(to right, rgba(${shadowColor === "black" ? "0,0,0" : "255,255,255"}, ${shadowIntensity}), transparent)`
    }} />

			{/* Right shadow */}
			<div className={cn("pointer-events-none absolute top-0 bottom-0 right-0 w-4 transition-opacity duration-200 z-10", showRightShadow ? "opacity-100" : "opacity-0")} style={{
      background: `linear-gradient(to left, rgba(${shadowColor === "black" ? "0,0,0" : "255,255,255"}, ${shadowIntensity}), transparent)`
    }} />
			<ScrollBar />
			<ScrollAreaPrimitive.Corner />
		</ScrollAreaPrimitive.Root>;
}
function ScrollBar(t0) {
  const $ = _c(13);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      orientation: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const t2 = orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent";
  const t3 = orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent";
  let t4;
  if ($[4] !== className || $[5] !== t2 || $[6] !== t3) {
    t4 = cn("flex touch-none p-px transition-colors select-none", t2, t3, className);
    $[4] = className;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ScrollAreaPrimitive.ScrollAreaThumb className="bg-border relative flex-1 rounded-full" data-slot="scroll-area-thumb" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== orientation || $[10] !== props || $[11] !== t4) {
    t6 = <ScrollAreaPrimitive.ScrollAreaScrollbar className={t4} data-slot="scroll-area-scrollbar" orientation={orientation} {...props}>{t5}</ScrollAreaPrimitive.ScrollAreaScrollbar>;
    $[9] = orientation;
    $[10] = props;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export { ScrollArea, ScrollBar };